import React, { useRef, useEffect, useState } from 'react';
import SanityImage from 'gatsby-plugin-sanity-image';
import { Box } from '@chakra-ui/react';

export default function Figure({ data }) {
  const { image, mobileImage } = data;
  const figureRef = useRef();
  const [isRightColumn, setIsRightColumn] = useState(false);

  // If the figure is in the right column, remove the padding
  useEffect(() => {
    const parentDiv = figureRef.current.parentNode;
    if (parentDiv.classList.contains('rightColumn')) {
      setIsRightColumn(true);
    }
  }, []);

  return (
    <Box
      ref={figureRef}
      as='figure'
      px={isRightColumn ? { base: 0, xl: 0 } : { base: 30, xl: 60 }}
      className='figure'
      position='relative'
    >
      <Box display={{ base: mobileImage ? 'none' : 'block', xl: 'block' }}>
        <SanityImage
          {...image}
          alt={image?.asset?.altText}
          width={isRightColumn ? 700 : 1200}
          hotspot={image.hotspot}
          crop={image.crop}
          style={{
            width: '100%',
            height: 'auto',
            objectFit: 'cover',
          }}
        />
      </Box>
      {mobileImage && (
        <Box display={{ base: 'block', xl: 'none' }}>
          <SanityImage
            {...mobileImage}
            alt={mobileImage?.asset?.altText}
            width={isRightColumn ? 700 : 1200}
            hotspot={mobileImage.hotspot}
            crop={mobileImage.crop}
            style={{
              width: '100%',
              height: 'auto',
              objectFit: 'cover',
            }}
          />
        </Box>
      )}
      {image?.asset?.title && (
        <Box
          as='figcaption'
          fontSize='sm'
          fontWeight={400}
          position='absolute'
          bottom={20}
          left={{ base: 50, xl: 80 }}
          zIndex='1'
          color='white'
          padding={5}
          background='rgba(0,0,0,.5)'
        >
          {image.asset.title}
        </Box>
      )}
    </Box>
  );
}
